import { createAction } from "redux-actions";
import { createRequestActionTypes } from "../../../common/saga/createRequestSaga";

export const [
  SEARCH_ALL_USERS,
  SEARCH_ALL_USERS_SUCCESS,
  SEARCH_ALL_USERS_FAILURE
] = createRequestActionTypes("admin/SEARCH_ALL_USERS");

export const [
  APPROVAL_USER,
  APPROVAL_USER_SUCCESS,
  APPROVAL_USER_FAILURE,
  APPROVAL_USER_INIT
] = createRequestActionTypes("admin/APPROVAL_USER");

export const [
  UPDATE_USE_YN,
  UPDATE_USE_YN_SUCCESS,
  UPDATE_USE_YN_FAILURE,
  UPDATE_USE_YN_INIT
] = createRequestActionTypes("admin/UPDATE_USE_YN");

export const [
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILURE,
  DELETE_USER_INIT
] = createRequestActionTypes("admin/DELETE_USER");

export const searchAllUsersAction = createAction(SEARCH_ALL_USERS);

export const approvalUserAction = createAction(
  APPROVAL_USER,
  ({ mbrId, status }) => ({ mbrId, status })
);
export const approvalUserInit = createAction(APPROVAL_USER_INIT);

export const updateUseYnAction = createAction(
  UPDATE_USE_YN,
  ({ mbrId, useYn }) => ({ mbrId, useYn })
);
export const updateUseYnInit = createAction(UPDATE_USE_YN_INIT);

export const deleteUserAction = createAction(
  DELETE_USER,
  ({ mbrId }) => ({ mbrId })
);
export const deleteUserInit = createAction(DELETE_USER_INIT);
